import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MessageCircle, Mail, MapPin, Phone } from "lucide-react";
import { PageHead, Reveal } from "../components/Reveal";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { INFO, PRODUCTS, waLink, WHATSAPP_DISPLAY } from "../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { nome: "", telefone: "", cidade: "", produto: "", mensagem: "" };

export default function Contato() {
  const [f, setF] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contatos`, f);
      toast.success("Mensagem enviada! Retornaremos em breve.");
      window.open(waLink(`Olá, SOLLUS! Sou ${f.nome} (${f.cidade}). Interesse: ${f.produto || "orçamento"}. ${f.mensagem}`), "_blank");
      setF(EMPTY);
    } catch {
      toast.error("Não foi possível enviar. Fale conosco pelo WhatsApp.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contato-page">
      <PageHead testid="contato-head" eyebrow="Atendimento" title="Fale conosco agora"
        text="Peça seu orçamento pelo formulário ou diretamente no WhatsApp comercial." />
      <div className="container-x grid gap-8 py-12 lg:grid-cols-[1fr_1.3fr]">
        <Reveal>
          <a href={waLink()} target="_blank" rel="noreferrer" data-testid="contato-whatsapp-card"
            className="block rounded-lg bg-brand p-7 text-white transition-transform hover:-translate-y-1">
            <MessageCircle className="h-7 w-7" />
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-white/90">WhatsApp comercial</p>
            <p className="mt-1 font-display text-4xl font-bold">{WHATSAPP_DISPLAY}</p>
            <p className="mt-2 text-sm text-white/90">Clique para iniciar a conversa</p>
          </a>
          <ul className="mt-6 space-y-4 text-sm text-steel">
            <li className="flex gap-3"><Phone className="h-5 w-5 shrink-0 text-brand" /><a href="tel:18996346993" className="hover:text-brand" data-testid="contato-telefone">{INFO.telefone}</a></li>
            <li className="flex gap-3"><Mail className="h-5 w-5 shrink-0 text-brand" /><a href={`mailto:${INFO.email}`} className="hover:text-brand" data-testid="contato-email">{INFO.email}</a></li>
            <li className="flex gap-3"><MapPin className="h-5 w-5 shrink-0 text-brand" /><a href={INFO.mapa} target="_blank" rel="noreferrer" className="hover:text-brand" data-testid="contato-mapa">{INFO.endereco}, {INFO.cidade}</a></li>
          </ul>
        </Reveal>
        <Reveal delay={0.1}>
          <form onSubmit={submit} className="grid gap-4 rounded-lg border border-line bg-white p-6 sm:grid-cols-2" data-testid="contact-form">
            <Input required placeholder="Nome *" value={f.nome} onChange={set("nome")} data-testid="contact-nome" />
            <Input required placeholder="Telefone / WhatsApp *" value={f.telefone} onChange={set("telefone")} data-testid="contact-telefone" />
            <Input placeholder="Cidade / UF" value={f.cidade} onChange={set("cidade")} data-testid="contact-cidade" />
            <select value={f.produto} onChange={set("produto")} data-testid="contact-produto"
              className="h-9 rounded-md border border-input bg-transparent px-3 text-sm">
              <option value="">Produto de interesse</option>
              {PRODUCTS.map((p) => <option key={p.slug} value={p.name}>{p.name}</option>)}
            </select>
            <Textarea placeholder="Mensagem" rows={5} value={f.mensagem} onChange={set("mensagem")} className="sm:col-span-2" data-testid="contact-mensagem" />
            <button disabled={sending} className="btn-red justify-center sm:col-span-2" data-testid="contact-form-submit-button">
              {sending ? "Enviando..." : "Enviar e falar no WhatsApp"}
            </button>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
